var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDailies = function SvgDailies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A2C",
    fillOpacity: 0.7,
    fillRule: "evenodd",
    d: "M20.834 16.557H4.166a.5.5 0 0 0 0 1h16.668a.5.5 0 0 0 0-1ZM19.003 19.6H5.996a.5.5 0 0 0 0 1h13.007a.5.5 0 1 0 0-1Zm3.372-5.588a.5.5 0 0 1-.5.5H3.125a.5.5 0 1 1 0-1h3.251A6.133 6.133 0 0 1 12.5 7.516a6.133 6.133 0 0 1 6.125 5.997h3.25a.5.5 0 0 1 .5.5ZM12.5 5.927a.5.5 0 0 0 .5-.5V2.9a.5.5 0 0 0-1 0v2.528a.5.5 0 0 0 .5.5Zm-6.162 2.26a.498.498 0 0 0 .707 0 .5.5 0 0 0 0-.708L5.257 5.692a.5.5 0 1 0-.707.708l1.788 1.787Zm11.617 0a.5.5 0 0 1 0-.708l1.788-1.787a.5.5 0 1 1 .707.708l-1.788 1.787a.499.499 0 0 1-.707 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgDailies;